<template>
  <div class="row justify-content-center my-5">
      <div class="col-lg-9 text-center" :class="color">
        <div class="row justify-content-left fotoDerecha" v-if="pos == 'fotoderecha'" data-aos="fade-up" data-aos-duration="1000">
            <div class="col-lg-6 text-left pl-4 pt-4">
                <h3 v-html="titulo"></h3>
                <div class="texto">{{ texto }}</div>
                <router-link :to="linkURL"><span v-html="textoURL"></span></router-link>
            </div>
            <div class="col-lg-6 p-0 m-0 contImagen">
                <img :src="imagen" />
            </div>
        </div>
        <div class="row justify-content-left fotoIzquierda" v-if="pos == 'fotoizquierda'" data-aos="fade-up" data-aos-duration="1000">
            <div class="col-lg-6 text-left pl-5 pt-4 order-lg-12">
                <h3 v-html="titulo"></h3>
                <div class="texto">{{ texto }}</div>
                <router-link :to="linkURL"><span v-html="textoURL"></span></router-link>
            </div>
            <div class="col-lg-6 p-0 m-0 contImagen order-lg-1">
                <img :src="imagen" />
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'BloqueFoto',
  props: {
    titulo: String,
    texto: String,
    linkURL: String,
    textoURL: String,
    imagen: String,
    pos: String,
    color: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  font-weight: 700;
  font-size: 22px;
}
.texto {
    font-size: 13px;
    padding: 10px 0 20px 15px;
    font-weight: 400;
}
.fotoDerecha img {
    width: 460px;
    position: absolute;
    margin: 15px 20px 0 0;
    left: 10px;
    /*-moz-box-shadow: 8px 8px 0 #000;
    -webkit-box-shadow: 8px 8px 0 #000;
    box-shadow: 8px 8px 0 #000;*/
}
.fotoIzquierda img {
    width: 460px;
    position: absolute;
    margin: 15px 20px 0 0;
    left: -50px;
    /*-moz-box-shadow: 8px 8px 0 #000;
    -webkit-box-shadow: 8px 8px 0 #000;
    box-shadow: 8px 8px 0 #000;*/
}
.contImagen {
    position: relative;
}
.azul {
    margin: 50px 0 50px 80px;
    background: rgb(128, 224, 255, .2);
    border: 5px solid #1900FF;
    padding: 20px 30px 50px 30px;
}
.morado {
    margin: 50px 80px 50px 0;
    background: rgb(161, 153, 255, .2);
    border: 5px solid #1900FF;
    padding: 20px 30px 50px 30px;
}
.azul2 {
    margin: 50px 80px 150px 0;
    background: rgb(128, 224, 255, .2);
    border: 5px solid #1900FF;
    padding: 20px 30px 50px 30px;
}
.cafe {
    margin: 50px 0 80px 80px;
    background: rgb(102, 102, 102, .2);
    border: 5px solid #1900FF;
    padding: 20px 30px 50px 30px;
}
a {
    color: #1900FF;
    font-size: 12px;
    font-weight: 700;
}
a:hover {
    text-decoration: none;
}
a span {
    text-decoration: underline;
}

a:after {
    content: ' --->';
    text-decoration: none;
}
@media only screen and (max-width: 990px){
    .azul {
        margin: 50px 10px 60%;
    }
    .azul2 {
        margin: 50px 10px 60%;
    }
    .morado {
        margin: 50px 10px 60%;
    }
    .cafe {
        margin: 50px 10px 60%;
    }
    .fotoDerecha img {
        width: 100%;
        left: 0;
    }
    .fotoIzquierda img {
        width: 100%;
        left: 0;
    }
}
@media only screen and (min-width: 1000px) and (max-width: 1024px){
    .fotoIzquierda img {
        left: -90px;
    }
}
</style>
